import styled from "styled-components";

export const Container = styled.div`
`;

export const Title = styled.span`
  color: #5A5A5A;
  font-size: 12px;
`;

export const ContentContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  
  span {
    color: #337ab7;
    font-size: 13px;
  }
`;
